module.exports = __webpack_public_path__ + "img/kalender-inactive.99d1a44.png";